import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PrimaryButton } from './PrimaryButton';
import { responseOutcomes } from '../../data/teaser';
type ReframeScreenProps = {
  answer: 'yes' | 'no' | null;
  onNext: () => void;
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function ReframeScreen({
  answer,
  onNext
}: ReframeScreenProps) {
  const reduced = useReducedMotion() ?? false;
  return <div className="flex h-full flex-col" data-id="element-850" data-mp="254tcu5ee7051">
      {answer && <p className="font-mono text-[11px] tracking-[0.16em] text-graphite" data-id="element-851" data-mp="2a2uwosjn73hk">
          YOU SAID <span className="text-ink" data-id="element-852" data-mp="2a0h3yqcfq3d6">{answer.toUpperCase()}</span> · HERE’S WHY IT MATTERS
        </p>}
      <h2 className="mt-3 text-[32px] font-semibold leading-[1.04] tracking-[-0.035em] text-ink" data-id="element-853" data-mp="2iv55q6isx2x8">The goal isn’t maximum stimulation.</h2>
      <p className="mt-3 text-[16px] leading-snug text-graphite" data-id="element-854" data-mp="1mc7m1zicdzrb">It’s an appropriate ovarian response for the individual patient.</p>

      <div className="mt-8" role="img" aria-label="Continuum from too little to too much response, with appropriate response in the middle" data-id="element-855" data-mp="1qcrggvbj6p9r">
        <div className="relative h-10" data-id="element-856" data-mp="2i2j4t6sicbih">
          <div className="absolute inset-x-0 top-1/2 flex h-[6px] -translate-y-1/2 overflow-hidden rounded-full" data-id="element-857" data-mp="2i3kqs6b2aiez">
            <span className="flex-1 bg-ink/10" data-id="element-858" data-mp="2da9hlyis1pjw" />
            <span className="w-[34%] bg-rx" data-id="element-859" data-mp="28e17x0ncmok4" />
            <span className="flex-1 bg-ink/10" data-id="element-860" data-mp="28czn44gj6np7" />
          </div>
          <motion.span className="absolute top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-white bg-rx shadow-[0_2px_10px_rgba(36,72,196,0.35)]" initial={{
          left: reduced ? '50%' : '12%'
        }} animate={{
          left: reduced ? '50%' : ['12%', '86%', '50%']
        }} transition={reduced ? {
          duration: 0
        } : {
          duration: 0.9,
          times: [0, 0.5, 1],
          ease: EASE,
          delay: 0.15
        }} data-id="element-861" data-mp="23f7s31klalgs" />
        </div>
        <div className="mt-1 grid grid-cols-[1fr_auto_1fr] items-start gap-2 font-mono text-[10px] tracking-[0.1em]" data-id="element-862" data-mp="3jser3s75qftt">
          <span className="text-graphite" data-id="element-863" data-mp="1i2pcfgjfmhdf">← TOO LITTLE</span>
          <span className="text-center font-medium text-rx" data-id="element-864" data-mp="1i15xpudfcedr">
            APPROPRIATE
            <br data-id="element-865" data-mp="1mva68i2c8ugy" />
            RESPONSE
          </span>
          <span className="text-right text-graphite" data-id="element-866" data-mp="185ug94amst2b">TOO MUCH →</span>
        </div>
      </div>

      <dl className="mt-6 border-b border-ink/10" data-id="element-867" data-mp="1d3mk8wojw5mv">
        {responseOutcomes.map(o => <div key={o.label} className="grid grid-cols-[104px_1fr] gap-3 border-t border-ink/10 py-3" data-id="element-868" data-mp="20t73lgom94wo">
            <dt className={`text-[13px] font-semibold ${o.primary ? 'text-rx' : 'text-ink'}`} data-id="element-869" data-mp="25tcxz4m9t5ig">{o.label}</dt>
            <dd className="text-[13px] leading-snug text-graphite" data-id="element-870" data-mp="1qwc4owofl2hv">{o.text}</dd>
          </div>)}
      </dl>

      <div className="mt-auto pt-6" data-id="element-871" data-mp="1vtcd3e8r6hc5">
        <PrimaryButton onClick={onNext} data-id="element-872" data-mp="1vwgoowojsfcu">CONTINUE</PrimaryButton>
      </div>
    </div>;
}